/** @jsx jsx */
import { jsx } from '@emotion/core'
import { FunctionComponent } from 'react'
import dayjs from 'dayjs'

import { TRequest } from '~/types'
import { styles } from './styles'

interface RequestProps {
  request: TRequest
}

export const Request: FunctionComponent<RequestProps> = ({ request }) => (
  <div
    css={[
      styles.container,
      Number(request.OffersCount) ? styles.accent : '',
      Number(request.AcceptedOffersCount) ? styles.acceptedAccent : '',
    ]}
  >
    <div css={styles.section}>
      <div css={styles.side}>
        <div css={[styles.items.name, styles.items.accent]}>{request.Name}</div>
      </div>
      <div css={styles.side}>
        <div css={styles.items.created}>
          {dayjs(+request.Created * 1000).format('MMMM D')}
        </div>
      </div>
    </div>
    <div css={styles.section}>
      <div css={styles.side}>
        <div css={styles.items.car}>
          {request.CarMake} {request.CarModel}
        </div>
      </div>
      <div css={styles.side}>
        <div
          css={[
            styles.items.offers,
            Number(request.OffersCount) && styles.items.accent,
            Number(request.AcceptedOffersCount) && styles.items.acceptedAccent,
          ]}
        >
          {request.OffersCount || '0'} offers
        </div>
      </div>
    </div>
  </div>
)
